export enum ExportStatusFilter {
    both = 'both',
    exported = 'exported',
    notExported = 'notExported',
    payoutsOnly = 'payoutsOnly',
}
